<div class="custom-field-details mb-5">
  <mat-card class="lum-mat-card">
    <mat-card-content>
      <div class="p-5">
        <div class="d-flex justify-content-between">
          <div class="align-self-center">
            <h3 class="mt-4 inline">Custom Field</h3>
          </div>
          <div class="align-self-center">
            <button
              type="button"
              class="lum-button lum-button--secondary"
              mat-button
              [routerLink]="['/custom-fields']"
            >
              <lum-ui-icon
                icon="chevron-left-circle"
                [width]="24"
                [height]="24"
                color="#5563d6"
              ></lum-ui-icon>
              Go Back To Custom Fields
            </button>
          </div>
        </div>
        <mat-divider class="my-2"></mat-divider>
      </div>
      <div class="p-5">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-4">
              <strong>Label</strong><br />
              <p>{{ customField?.label }}</p>
            </div>
            <div class="mb-4">
              <strong>Type</strong><br />
              <mat-chip
                *ngIf="customField?.type; else noData"
                class="
                  lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
                "
                >{{ customField.type }}</mat-chip
              >
            </div>
            <div
              class="mb-4"
              *ngIf="customField?.type === eCustomFieldType.DROPDOWN"
            >
              <strong>Options</strong><br />
              <ul>
                <li *ngFor="let option of customField.options">{{ option }}</li>
              </ul>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4">
              <strong>Custom Field Objects</strong><br />
              <div *ngIf="customField?.customFieldObjectTypes?.length; else noData">
                <mat-chip-list>
                  <mat-chip
                    *ngFor="let objectType of customField.customFieldObjectTypes; trackBy: trackById"
                    class="lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small"
                  >
                    {{ objectType | customFieldObjectLabel }}
                  </mat-chip>
                </mat-chip-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <div class="mb-5"></div>
  <ng-template #noData>
    <strong>N/A</strong>
  </ng-template>
</div>
